import React ,{ Component }from "react";
import { FiCast , FiLayers , FiUsers , FiMonitor, FiSmartphone, FiCamera, FiEdit, FiPercent, FiStar, FiPenTool } from "react-icons/fi";

const ServiceList = [
    {
        icon: <FiSmartphone />,
        title: 'Crafting Digital Solutions',
        description: `Engineer seamless and robust digital experience. Various experience in building high-performance iOS/Android apps to scalable full stack web architecture`
    },
    // {
    //     icon: <FiLayers />,
    //     title: 'Website Development',
    //     description: 'Expertise: Front-End Development'
    // },
    // {
    //     icon: <FiUsers />,
    //     title: 'UI/UX Design',
    //     description: 'Experience in building digital experience for financial sector'
    // },
    {
        icon: <FiPenTool />,
        title: 'Product Management',
        description: 'Focusing on technical strategy to ensure implementation aligns with requirements and bussiness objectives'
    },
    // {
    //     icon: <FiStar />,
    //     title: 'Collaborative Approach & Hard Work',
    //     description: 'Alone we can do so little, together we can do so much more!'
    // },
    // {
    //     icon: <FiPercent />,
    //     title: 'Full Commitment',
    //     description: '100% is what I always give to the project'
    // },
]


class ServiceThree extends Component{
    render(){
        const {column } = this.props;
        const ServiceContent = ServiceList.slice(0 , this.props.item);
        
        return(
            <React.Fragment>
                <div className="row">
                    {ServiceContent.map( (val , i) => (
                        <div className={`${column}`} key={i}>
                            <a>
                                <div className="service service__style--2">
                                    <div className="icon">
                                        {val.icon}
                                    </div>
                                    <div className="content">
                                        <h3 className="title">{val.title}</h3>
                                        <p>{val.description}</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceThree;
